import React, { Fragment, MutableRefObject } from "react";

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import CustomSpinner from "../../custom-spinner/custom-spinner";
import { ISearchData } from "../interface";
import { NoResults } from "./noResults";
import Icon from "components/icon";
import { SearchResult } from "./search-result";

interface IDropdownGlobalSearchProps {
    searchData: ISearchData;
    isLoading: boolean;
    dropdownRef: MutableRefObject<HTMLDivElement | null>;
}

export const DropdownGlobalSearch = ({ searchData, isLoading, dropdownRef }: IDropdownGlobalSearchProps) => {
    const { t } = useTranslation();

    return (
        <div className="gs-dropdown-container">
            <div className="gs-dropdown " ref={dropdownRef}>
                {isLoading ? (
                    <CustomSpinner />
                ) : Object.values(searchData).every((value) => !value.length) ? (
                    <NoResults />
                ) : (
                    Object.entries(searchData).map(([key, value], index) => <SearchResult key={index} model={key} value={value} />)
                )}
            </div>
        </div>
    );
};
